import { GALLERY_SORTBY_STATS, type GallerySortbySlugType } from '@/defs/gallery'
import { type StatType } from '@/defs/stat'

const STATS_MAX = 3

type Props = {
  sortby: GallerySortbySlugType
  stats?: StatType[]
}

export const getGalleryStats = ({ sortby, stats }: Props) => {
  const statsSortby = GALLERY_SORTBY_STATS[sortby]
  if (!stats?.length || !statsSortby || stats.some((s) => statsSortby.includes(s))) return stats
  return [...stats.slice(0, STATS_MAX - 1), statsSortby[0]]
}
